export default __webpack_public_path__ + "static/media/cientifica2.b11b98f6.jpg";